import { useCallback, useMemo } from 'react';
import { Button, useGetIdentity, useUpdate } from 'react-admin';

export const AdminGrantButton = ({ record }: { record: any }) => {
  const isAdmin = useMemo(() => !!record.adminGrantedAt, [record]);

  const userId = useGetIdentity().data?.id?.toString();

  const isSameUser = useMemo(
    () => record.id === userId,
    [record, userId],
  );

  const [update, { isLoading }] = useUpdate();

  const onClick = useCallback(async () => {
    if (isSameUser) {
      return;
    }

    const now = new Date();

    await update('userMetadata', {
      id: record.id,
      data: {
        adminGrantedAt: isAdmin ? null : now,
        adminGrantedBy: userId,
        lastUpdatedBy: userId,
        lastUpdatedAt: now,
      },
    });

    // refresh();
  }, [record, userId, update, isSameUser, isAdmin]);

  return isSameUser ? null : (
    <Button
      color={isAdmin ? 'error' : 'success'}
      variant={isAdmin ? 'text' : 'contained'}
      disabled={isLoading}
      onClick={onClick}
      label={
        isAdmin
          ? 'Revoke Admin Priviledges'
          : 'Grant Admin Priviledges'
      }
      style={{ textTransform: 'none' }}
    />
  );
};
